import { Navigate, useLocation } from "react-router-dom";
import { useAuth, isStaff } from "@/context/AuthContext";

export default function ProtectedRoute({ children, staffOnly = false, customerOnly = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null)
    return <div className="grid min-h-screen place-items-center text-muted-foreground">Loading...</div>;
  if (!user)
    return <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />;
  if (staffOnly && !isStaff(user)) return <Navigate to="/portal" replace />;
  if (customerOnly && isStaff(user)) return <Navigate to="/admin" replace />;
  return children;
}
